export default __webpack_public_path__ + "static/media/alphonso-davies.d01e6b66.jpg";